import React from 'react'
import { $neutralGray100 } from '../../styles/colors/primitives'

function ChevronDownIcon() {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 6.00005L0 1.00005L0.7 0.300049L5 4.60005L9.3 0.300049L10 1.00005L5 6.00005Z" fill={$neutralGray100}/>
    </svg>
  )
}

export default ChevronDownIcon
